import {useCallback, useState} from "react";
import {css, cx} from "@panda/css";

import {useElementInteractionObserver} from "../../../hooks/use_element_interaction_observer";
import {OpenStreetMapsWithPoi} from "../../../maps/components/map_with_poi/OpenStreetMapsWithPoi";
import {POI_DISTANCE_DEFAULT_VALUE} from "../../../maps/constants/pois_defaults";
import {useMapNearbyOffersPois} from "../../../maps/hooks/use_map_nearby_offers_pois";
import {poiAnalytics, PoiGTMModalAction} from "../../../maps/tracking/poi_analytics";
import {trackAmplitudeMapPoiClick} from "../../../maps/tracking/track_amplitude_poi_click";
import {OsmPoiClickHandler} from "../../../maps/utils/create_get_osm_poi_marker";
import {getHasCountryPois} from "../../../maps/utils/get_has_country_pois";
import {ViewType} from "../../../view_type/ViewType";
import {IOfferDetail} from "../../types/IOfferDetail";
import {IOfferModalOffer} from "../../types/OfferModalOffer";

interface IProps {
    className?: string;
    offer: IOfferDetail | IOfferModalOffer;
    area?: {
        center: {
            coordinates: [number, number];
        };
        polygon: {
            coordinates: number[][][];
        };
        region: number;
    };
    property?: {
        id: number;
        for_sale: boolean;
    };
    disablePoiSwitch?: boolean;
    defaultZoom?: number;
    disableClusterMarkers?: boolean;
    onFullscreenClick?: () => void;
}

export const OfferDetailLocationMap = (props: IProps) => {
    const {offer, className, area, property, disablePoiSwitch, defaultZoom, disableClusterMarkers, onFullscreenClick} = props;

    const [poiDistance, setPoiDistance] = useState<number>(POI_DISTANCE_DEFAULT_VALUE);

    const hasCountryPois = getHasCountryPois(offer.region.country);

    const {offerAdditionalPois, defaultPoiTypes, mapBottomSlot} = useMapNearbyOffersPois({
        baseOffer: {
            id: offer.id,
            type: offer.type,
            stats:
                "stats" in offer && offer.stats
                    ? {
                          ranges_area_min: "ranges_area_min" in offer.stats ? offer.stats.ranges_area_min : undefined,
                          ranges_area_max: "ranges_area_max" in offer.stats ? offer.stats.ranges_area_max : undefined,
                          rooms: "rooms" in offer.stats ? offer.stats.rooms : undefined
                      }
                    : undefined
        },
        distance: poiDistance,
        showPropertyNumberOnMarker: !!property
    });

    const mapWrapperRef = useElementInteractionObserver<HTMLDivElement>({
        callback: () => {
            poiAnalytics.gtm.mapEvent({action: PoiGTMModalAction.MAP_FIRST_INTERACTION});
        },
        once: true
    });

    const onPoiClick = useCallback<OsmPoiClickHandler>(
        (poi, poiType, poiSubType) => {
            trackAmplitudeMapPoiClick({
                location: property ? "property_page" : "investment_page",
                poi,
                poiType,
                poiSubType,
                itemId: offer.id,
                propertyId: property?.id ?? null
            });
        },
        [offer.id, property?.id]
    );

    return (
        <div ref={mapWrapperRef} className={cx(mapContainerStyle, className)}>
            <OpenStreetMapsWithPoi
                offer={offer}
                viewType={property ? ViewType.PROPERTY : ViewType.OFFER}
                polygon={area && area.polygon}
                region={area && area.region}
                disableInitiallyOpenedPoiId
                mapConfig={{
                    scrollWheelZoom: false,
                    fitBounds: true,
                    fitBoundsDefaultZoom: defaultZoom,
                    maxZoom: 18
                }}
                mobilePoiModalTriggerPosition="center"
                customPoiMarkers={offerAdditionalPois}
                clusterMarkers={!disableClusterMarkers}
                disablePoiSwitch={!hasCountryPois || disablePoiSwitch}
                initialPoiTypes={defaultPoiTypes}
                mapBottomSlot={mapBottomSlot}
                className={mapCustomStylesStyle}
                onFullscreenClick={onFullscreenClick}
                onPoiClick={onPoiClick}
                drawPoiDistance
                onDistanceChange={setPoiDistance}
            />
        </div>
    );
};

const mapContainerStyle = css({
    position: "relative",
    height: "58rem",

    // md: to avoid scroll on map sidebar with default params
    md: {
        height: "68rem"
    }
});

const mapCustomStylesStyle = css({
    "& .leaflet-div-icon": {
        backgroundColor: "transparent !important",
        border: "none !important"
    }
});
import {useCallback, useState} from "react";
import {css, cx} from "@panda/css";

import {useElementInteractionObserver} from "../../../hooks/use_element_interaction_observer";
import {OpenStreetMapsWithPoi} from "../../../maps/components/map_with_poi/OpenStreetMapsWithPoi";
import {POI_DISTANCE_DEFAULT_VALUE} from "../../../maps/constants/pois_defaults";
import {useMapNearbyOffersPois} from "../../../maps/hooks/use_map_nearby_offers_pois";
import {poiAnalytics, PoiGTMModalAction} from "../../../maps/tracking/poi_analytics";
import {trackAmplitudeMapPoiClick} from "../../../maps/tracking/track_amplitude_poi_click";
import {OsmPoiClickHandler} from "../../../maps/utils/create_get_osm_poi_marker";
import {getHasCountryPois} from "../../../maps/utils/get_has_country_pois";
import {ViewType} from "../../../view_type/ViewType";
import {IOfferDetail} from "../../types/IOfferDetail";
import {IOfferModalOffer} from "../../types/OfferModalOffer";

interface IProps {
    className?: string;
    offer: IOfferDetail | IOfferModalOffer;
    area?: {
        center: {
            coordinates: [number, number];
        };
        polygon: {
            coordinates: number[][][];
        };
        region: number;
    };
    property?: {
        id: number;
        for_sale: boolean;
    };
    disablePoiSwitch?: boolean;
    defaultZoom?: number;
    disableClusterMarkers?: boolean;
    onFullscreenClick?: () => void;
}

export const OfferDetailLocationMap = (props: IProps) => {
    const {offer, className, area, property, disablePoiSwitch, defaultZoom, disableClusterMarkers, onFullscreenClick} = props;

    const [poiDistance, setPoiDistance] = useState<number>(POI_DISTANCE_DEFAULT_VALUE);

    const hasCountryPois = getHasCountryPois(offer.region.country);

    const {offerAdditionalPois, defaultPoiTypes, mapBottomSlot} = useMapNearbyOffersPois({
        baseOffer: {
            id: offer.id,
            type: offer.type,
            stats:
                "stats" in offer && offer.stats
                    ? {
                          ranges_area_min: "ranges_area_min" in offer.stats ? offer.stats.ranges_area_min : undefined,
                          ranges_area_max: "ranges_area_max" in offer.stats ? offer.stats.ranges_area_max : undefined,
                          rooms: "rooms" in offer.stats ? offer.stats.rooms : undefined
                      }
                    : undefined
        },
        distance: poiDistance,
        showPropertyNumberOnMarker: !!property
    });

    const mapWrapperRef = useElementInteractionObserver<HTMLDivElement>({
        callback: () => {
            poiAnalytics.gtm.mapEvent({action: PoiGTMModalAction.MAP_FIRST_INTERACTION});
        },
        once: true
    });

    const onPoiClick = useCallback<OsmPoiClickHandler>(
        (poi, poiType, poiSubType) => {
            trackAmplitudeMapPoiClick({
                location: property ? "property_page" : "investment_page",
                poi,
                poiType,
                poiSubType,
                itemId: offer.id,
                propertyId: property?.id ?? null
            });
        },
        [offer.id, property?.id]
    );

    return (
        <div ref={mapWrapperRef} className={cx(mapContainerStyle, className)}>
            <OpenStreetMapsWithPoi
                offer={offer}
                viewType={property ? ViewType.PROPERTY : ViewType.OFFER}
                polygon={area && area.polygon}
                region={area && area.region}
                disableInitiallyOpenedPoiId
                mapConfig={{
                    scrollWheelZoom: false,
                    fitBounds: true,
                    fitBoundsDefaultZoom: defaultZoom,
                    maxZoom: 18
                }}
                mobilePoiModalTriggerPosition="center"
                customPoiMarkers={offerAdditionalPois}
                clusterMarkers={!disableClusterMarkers}
                disablePoiSwitch={!hasCountryPois || disablePoiSwitch}
                initialPoiTypes={defaultPoiTypes}
                mapBottomSlot={mapBottomSlot}
                className={mapCustomStylesStyle}
                onFullscreenClick={onFullscreenClick}
                onPoiClick={onPoiClick}
                drawPoiDistance
                onDistanceChange={setPoiDistance}
            />
        </div>
    );
};

const mapContainerStyle = css({
    position: "relative",
    height: "58rem",

    // md: to avoid scroll on map sidebar with default params
    md: {
        height: "68rem"
    }
});

const mapCustomStylesStyle = css({
    "& .leaflet-div-icon": {
        backgroundColor: "transparent !important",
        border: "none !important"
    }
});
